export default theme => ({
  root: {},
  overlay: {
    zIndex: 1601
  },
  content: {
    position: 'relative'
  },
  advice: {
    marginBottom: '24px'
  },
  formContainer: {
    opacity: 1,
    transition: 'all .15s ease'
  },
  formContainerHidden: {
    opacity: 0
  },
  loaderContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  }
});